"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerTabClickEvent = triggerTabClickEvent;
exports.triggerHoverCardElementEvent = triggerHoverCardElementEvent;
exports.triggerClickCardEvent = triggerClickCardEvent;
exports.triggerOpenModalEvent = triggerOpenModalEvent;
exports.triggerCloseModalEvent = triggerCloseModalEvent;
const universal_analytics_1 = require("@zillow/universal-analytics");
/**
 * Triggers clickstream event of "click interaction" on tab.
 *
 * @param {Object} inputs
 * @param {String} inputs.label
 * @param {String} [inputs.id=undefined]
 *
 * @returns {void}
 */
function triggerTabClickEvent(inputs) {
    (0, universal_analytics_1.event)({
        // https://dataportal.zillowgroup.net/event-registry/2048
        envelope: {
            event_type_id: '2048',
            event_type_version_id: '1',
            event_template_id: '126',
            event_template_version_id: '1',
        },
        clickstream_trigger: {
            trigger_type_nm: 'interaction',
            trigger_location_nm: 'cms',
            trigger_source_nm: 'cms_tab',
            trigger_object_nm: 'no_trigger_object',
        },
        semantic: {
            semantic_event_nm: 'cms_click',
        },
        cms_info: {
            block_id: inputs.id || '',
            block_type_cd: 'tab',
            block_displayed_txt: inputs.label,
        },
    });
}
function triggerHoverCardElementEvent(blockId, element, blockDisplayedTxt) {
    (0, universal_analytics_1.event)({
        envelope: {
            event_type_id: '2049',
            event_type_version_id: '1',
            event_template_id: '126',
            event_template_version_id: '1',
        },
        clickstream_trigger: {
            trigger_type_nm: 'interaction',
            trigger_location_nm: 'cms',
            trigger_source_nm: `cms_${element}`,
            trigger_object_nm: 'no_trigger_object',
        },
        semantic: {
            semantic_event_nm: 'cms_hover',
        },
        cms_info: {
            block_id: blockId,
            block_type_cd: element,
            block_displayed_txt: blockDisplayedTxt,
        },
    });
}
function triggerClickCardEvent(blockId, blockDisplayedTxt) {
    (0, universal_analytics_1.event)({
        envelope: {
            event_type_id: '2048',
            event_type_version_id: '2',
            event_template_id: '126',
            event_template_version_id: '1',
        },
        clickstream_trigger: {
            trigger_type_nm: 'interaction',
            trigger_location_nm: 'cms',
            trigger_source_nm: 'cms_button',
            trigger_object_nm: 'no_trigger_object',
        },
        semantic: {
            semantic_event_nm: 'cms_click',
        },
        cms_info: {
            block_type_cd: 'button',
            block_id: blockId,
            block_displayed_txt: blockDisplayedTxt,
        },
    });
}
function triggerOpenModalEvent(blockId, blockDisplayedTxt) {
    (0, universal_analytics_1.event)({
        envelope: {
            event_type_id: '5030',
            event_type_version_id: '2',
            event_template_id: '126',
            event_template_version_id: '1',
        },
        clickstream_trigger: {
            trigger_type_nm: 'interaction',
            trigger_location_nm: 'cms',
            trigger_source_nm: 'cms_modal',
            trigger_object_nm: 'no_trigger_object',
        },
        semantic: {
            semantic_event_nm: 'cms_open',
        },
        cms_info: {
            block_type_cd: 'button',
            block_id: blockId,
            block_displayed_txt: blockDisplayedTxt,
        },
    });
}
function triggerCloseModalEvent() {
    (0, universal_analytics_1.event)({
        envelope: {
            event_type_id: '2051',
            event_type_version_id: '2',
            event_template_id: '126',
            event_template_version_id: '1',
        },
        clickstream_trigger: {
            trigger_type_nm: 'interaction',
            trigger_location_nm: 'cms',
            trigger_source_nm: 'cms_modal',
            trigger_object_nm: 'no_trigger_object',
        },
        semantic: {
            semantic_event_nm: 'cms_close',
        },
        cms_info: {
            block_type_cd: 'button',
            block_id: 'rate-card-modal',
            block_displayed_txt: '',
        },
    });
}
